import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = (...args) => (_ctx.openReclassify && _ctx.openReclassify(...args))),
      class: "btn btn-default btn-flat float-right"
    }, " Reclassificação "),
    _cache[2] || (_cache[2] = _createTextVNode("   ")),
    _createElementVNode("button", {
      onClick: _cache[1] || (_cache[1] = (...args) => (_ctx.openCredentials && _ctx.openCredentials(...args))),
      class: "btn btn-default btn-flat float-right"
    }, " Credenciais "),
    _cache[3] || (_cache[3] = _createTextVNode("   "))
  ], 64))
}